import { render } from "./ChartReadme.vue?vue&type=template&id=2e564e7a&scoped=true"
import script from "./ChartReadme.vue?vue&type=script&lang=js"
export * from "./ChartReadme.vue?vue&type=script&lang=js"

import "./ChartReadme.vue?vue&type=style&index=0&id=2e564e7a&lang=scss&scoped=true"

import exportComponent from "../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e564e7a"]])

export default __exports__